import { Controller } from 'stimulus';

export default class extends Controller {
  static values = {
    action: String,
  };

  addShadow() {
    if (this.element.checked) {
      this.actionValue = 'left_tool_bar_drop_shadow_applied';
      this.track();
    }
  }

  trackSidepanelToggle(e) {
    const sidepanelId = e.currentTarget.dataset.sidepanelId;
    const active = e.currentTarget.classList.contains('is-active');

    if (!active) {
      const actions = {
        my_library: 'my_library_panel_opened',
        products: 'product_panel_opened',
        rooms: 'background_panel_opened',
        text: 'text_panel_opened',
        elements: 'visual_elements_panel_opened',
        swatches: 'swatch_panel_opened',
        templates: 'templates_panel_opened',
      };
      const action = actions[sidepanelId];
      if (action) {
        window.ed.featureActionsService.add(action);
      }
    }
  }

  trackUploads({ detail }) {
    const actions = {
      manual_library: 'library_item_upload_clicked',
      manual_project_items: 'project_items_item_upload_clicked',
      manual_asset: 'assets_item_upload_clicked',
      paste_library: 'library_item_uploaded_by_pasting',
      paste_project_items: 'project_items_item_uploaded_by_pasting',
      paste_asset: 'assets_item_uploaded_by_pasting',
      drop_library: 'library_item_uploaded_by_drop',
      drop_project_items: 'project_items_item_uploaded_by_drop',
      drop_asset: 'assets_item_uploaded_by_drop',
    };

    const action = actions[`${detail['source']}_${detail['location']}`];

    if (action && window.ed) {
      window.ed.featureActionsService.add(action);
    }
  }

  track() {
    if (window.ed) {
      window.ed.featureActionsService.add(this.actionValue);
    }
  }
}
